import { useTranslation } from 'react-i18next';
import { useInboxSummaryQuery } from './useInbox';

/** The count is capped visually; the accessible text always names the real number. */
const BADGE_CAP = 99;

/**
 * The open-message count after "Inbox" in the navigation (style guide 2.43):
 * `--danger` while a critical message is open, `--warn` while the worst is a
 * warning. The visual badge is hidden from assistive technology; a visually
 * hidden sentence carries the count. A failing or empty summary draws nothing
 * (the page itself has the error state).
 */
export function InboxNavBadge() {
  const { t } = useTranslation();
  const summary = useInboxSummaryQuery();
  const counts = summary.data;
  if (!counts?.total) return null;
  const tone = counts.critical > 0 ? 'ui-badge ui-badge--danger' : counts.warning > 0 ? 'ui-badge ui-badge--warn' : 'ui-badge';
  return (
    <>
      <span className={tone} aria-hidden="true">
        {counts.total > BADGE_CAP ? `${BADGE_CAP}+` : counts.total}
      </span>
      <span className="ui-visually-hidden">{t('inbox.nav.open', { count: counts.total })}</span>
    </>
  );
}
